export default "__VITE_ASSET__ByawaHxi__"